module.exports = __webpack_public_path__ + "img/BoD_07_Mr_Jeyaraj_Indra_Raj.097cccd9.jpg";